module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAAHhSr/lAAAAAXNSR0IArs4c6QAAAK9JREFUSA3tVLsRgDAINZ6FY9g5jneOYuHSlg4QtSUQwHueFEnH//EIpGOac0deyvcjui6d214qPwinhR+ZRcQ6coBeO/ZcJNWZsNkycRQX5SwdJosTzSzJJuxSMNWb2KJBkoxFFpezsMigA4Ami/vPoG1Ck7EnXto9TR/3BGE5Q+6mxqnHDu3SU1jzDQtsGNdFA/+LHXrLkB2EHWUD5h0z9Fx7i9f82yhr7HC2sIxdleJCh1YUNl4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/Austria.png
// module id = 497
// module chunks = 7